import script from "./RestorePurchasesButton.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./RestorePurchasesButton.vue?vue&type=script&lang=js"
export * from "./RestorePurchasesButton.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./RestorePurchasesButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/plan-sheet/RestorePurchasesButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c3048306"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c3048306', __exports__)) {
    api.reload('c3048306', __exports__)
  }
  
}


export default __exports__